import { type FormValues } from '@uturn/portal/modules/shipments/schema';
import { TypeOfShipment } from '@uturn/portal/types/shipment';
import {
	addValidationIssue,
	type ValidationResults,
	validationSuccess,
} from '@uturn/portal/types/validation';
import { useTranslation } from 'react-i18next';
import { z } from 'zod';

export function useGroupedShipmentValidation() {
	const { t } = useTranslation();
	/**
	 * Grouped shipments validation.
	 *
	 * @param newGroupName
	 * @param numberOfCopiesToBeCreated
	 * @param typeOfShipment
	 * @param validationResults
	 * @returns
	 */
	const validateGroupedShipment = (
		newGroupName: string,
		numberOfCopiesToBeCreated: number,
		typeOfShipment: TypeOfShipment,
		validationResults?: ValidationResults<FormValues>,
	): ValidationResults<FormValues> => {
		let results = validationResults ?? validationSuccess;

		if (typeOfShipment !== TypeOfShipment.GROUP) {
			return results;
		}

		const newGroupNameSchema = z
			.string({
				required_error: t(
					'general.errors.form_validation.required',
					'Required.',
				).toString(),
			})
			.min(2);

		try {
			newGroupNameSchema.parse(newGroupName);
		} catch (err) {
			if (err instanceof z.ZodError) {
				results = addValidationIssue<FormValues>(
					results,
					err.issues[0].message,
					'newGroup.name',
				);
			}
		}

		const numberOfCopiesToBeCreatedSchema = z.number().min(2);

		try {
			numberOfCopiesToBeCreatedSchema.parse(numberOfCopiesToBeCreated);
		} catch (err) {
			if (err instanceof z.ZodError) {
				results = addValidationIssue<FormValues>(
					results,
					err.issues[0].message,
					'numberOfCopiesToBeCreated',
				);
			}
		}
		return results;
	};
	return { validateGroupedShipment };
}
